export const MOVE_STATE = "/fund/state_movement/:id/";
export const GET_STATES = "/fund/poll_state/:id/";
